import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { useContext, useState } from "react";
import { useEffect } from "react";
import { Actions, store } from "../../util/store";
import { getTypeColor } from "./typeColors";
import { makeStyles } from "@mui/styles";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    backgroundColor: "white",
  },
  chips: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    "&::-webkit-scrollbar": { display: "none" },
    scrollbarWidth: "none",
  },
  chip: {
    margin: 2,
  },
  formControl: {
    marginLeft: "15px !important",
    marginRight: "15px !important",
    marginBottom: "5px !important",
  },
  noFocusHighlight: {
    "&:focus": { backgroundColor: "white" },
    display: "flex !important",
    alignItems: "center",
  },
  img: {
    marginRight: "15px",
    borderRadius: "100%",
  },
});

const menuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
};

const Filters = (props) => {
  const classes = useStyles();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedTypes, setSelectedTypes] = useState([]);
  const { dispatch, countries, types } = useContext(store);
  let [searchParams, setSearchParams] = useSearchParams();

  const updateFilterSearchParams = ({ country, type }) => {
    const nextParams = new URLSearchParams(searchParams);

    nextParams.delete("country");
    nextParams.delete("type");

    if (country) {
      nextParams.set("country", country);
    }

    if (Array.isArray(type)) {
      type.forEach((t) => {
        if (t) {
          nextParams.append("type", t);
        }
      });
    }

    setSearchParams(nextParams);
  };

  useEffect(() => {
    const countryParam = searchParams.get("country");
    const typeParams = searchParams.getAll("type");
    if (countryParam) {
      setSelectedCountry(countryParam);
    }
    if (typeParams) {
      setSelectedTypes(typeParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const preloadImages = () => {
      countries.forEach((country) => {
        const img = new Image();
        img.src = `/images/flags/${country
          .toLowerCase()
          .replace(/ /g, "-")}.png`;
      });
    };

    preloadImages();
  }, [countries]);

  useEffect(() => {
    const countryParam = searchParams.get("country");
    const typeParams = searchParams
      .getAll("type")
      .filter((param) => param && param !== "null");
    const nextParams = new URLSearchParams(searchParams);

    if (!countryParam || countryParam === "null") {
      nextParams.delete("country");
    } else {
      nextParams.set("country", countryParam);
    }

    nextParams.delete("type");
    typeParams.forEach((type) => {
      nextParams.append("type", type);
    });

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams);
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    dispatch({ type: Actions.SET_TYPE_FILTER, payload: selectedTypes });
  }, [dispatch, selectedTypes]);

  useEffect(() => {
    dispatch({ type: Actions.SET_COUNTRY_FILTER, payload: selectedCountry });
  }, [dispatch, selectedCountry]);

  const handleCountryChange = (event) => {
    updateFilterSearchParams({
      type: searchParams.getAll("type"),
      country: event.target.value,
    });
    setSelectedCountry(event.target.value);
  };

  const handleTypeChange = (event) => {
    updateFilterSearchParams({
      country: searchParams.get("country"),
      type: event.target.value,
    });
    setSelectedTypes(event.target.value);
  };

  const handleDeleteChip = (value) => () => {
    const updatedTypes = selectedTypes.filter((type) => type !== value);
    updateFilterSearchParams({ type: updatedTypes, country: selectedCountry });
    setSelectedTypes(updatedTypes);
  };

  const typeRenderer = (selected) => (
    <div className={classes.chips} onWheel={(e) => e.stopPropagation()}>
      {selected.map((value) => (
        <Chip
          key={value}
          label={value}
          className={classes.chip}
          style={{ backgroundColor: getTypeColor(value), color: "#000000" }}
          onDelete={handleDeleteChip(value)}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
        />
      ))}
    </div>
  );

  return (
    <div className={classes.root}>
      <FormControl className={classes.formControl} size="small">
        <InputLabel id="countryFilterLabel">Country</InputLabel>
        <Select
          classes={{ select: classes.noFocusHighlight }}
          MenuProps={menuProps}
          value={selectedCountry}
          defaultValue=""
          onChange={handleCountryChange}
          label="Country"
          labelId="countryFilterLabel"
          sx={{ height: "40px" }}
        >
          <MenuItem key="" value="">
            <ListItemText primary="No filter" />
          </MenuItem>
          {countries?.map((country) => (
            <MenuItem key={country} value={country}>
              <img
                src={`/images/flags/${country
                  .toLowerCase()
                  .replace(/ /g, "-")}.png`}
                alt={`${country}_flag_icon`}
                height="30px"
                className={classes.img}
              />
              <ListItemText primary={country} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl className={classes.formControl} size="small">
        <InputLabel id="typeFilterLabel">Type</InputLabel>
        <Select
          MenuProps={menuProps}
          classes={{ select: classes.noFocusHighlight }}
          multiple={true}
          value={selectedTypes}
          onChange={handleTypeChange}
          renderValue={typeRenderer}
          label="Type"
          labelId="typeFilterLabel"
          sx={{ height: "40px" }}
        >
          {types?.map((type, index) => (
            <MenuItem key={type} value={type}>
              <Checkbox checked={selectedTypes.indexOf(type) > -1} />
              <ListItemText
                primary={
                  <Chip
                    style={{
                      backgroundColor: getTypeColor(type),
                      color: "#000000",
                    }}
                    classes={{ root: classes.chip }}
                    key={type + index}
                    label={type}
                  />
                }
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default Filters;
